/**
 * Generate a v4 UUID
 * Fallback function for environments where crypto.randomUUID() is not available
 * (e.g., non-secure contexts like HTTP from non-localhost origins)
 */
export function generateUUID(): string {
  // Try to use crypto.randomUUID() if available (secure contexts)
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  // Fallback: generate UUID v4 manually
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
